import React, { useState, useEffect } from "react";

import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import Input from "@mui/material/Input";
import Typography from "@mui/material/Typography";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import { getFinalKeySegment, snakeToTitle } from "../utils";
// import { FormControl } from '@mui/material';

let columnOptions = [];

const ReactionSearchCriteria = ({
  searchColumns,
  onSearch,
  searchConfig,
  data,
}) => {
  // Transform the available columns into options for react-select
  if (columnOptions.length === 0 && searchColumns) {
    columnOptions = searchColumns.map((col) => ({
      value: col,
      label: snakeToTitle(getFinalKeySegment(col)),
    }));
  }

  //const [queryParams, setQueryParams] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("reaction");
  const [searchFilters, setSearchFilters] = useState([
    { column: "", searchText: "" },
  ]);
  const [autocompletes, setAutocompletes] = useState([[]]);

  const handleColumnChange = (index, col) => {
    const newFilters = [...searchFilters];
    newFilters[index].column = col;
    setSearchFilters(newFilters);

    const newAutocompletes = [...autocompletes];
    const finalCol = getFinalKeySegment(col);
    const auto = data
      .map((item) => String(item[getFinalKeySegment(finalCol)]))
      .filter(
        (item) =>
          item !== null &&
          item !== undefined &&
          item !== "null" &&
          item !== "undefined",
      );
    newAutocompletes[index] = Array.from(new Set(auto)).sort();
    setAutocompletes(newAutocompletes);
    if (data.length == 0) {
      let templateData = [
        {
          catalyst_elements: "Ag",
          catalyst_facet: "001",
          potential: -1.0,
          reaction_type: "NRR",
        },
        {
          catalyst_elements: "C",
          catalyst_facet: "100",
          potential: -0.25,
          reaction_type: "CO2R_OCHO",
        },
        {
          catalyst_elements: "O",
          catalyst_facet: "110",
          potential: 1.23,
          reaction_type: "CO2R_OCHO",
        },
        {
          catalyst_elements: "Co",
          catalyst_facet: "011",
          potential: 1.23,
          reaction_type: "CO2R_OCHO",
        },
        {
          catalyst_elements: "Ni",
          catalyst_facet: "011",
          potential: 1.23,
          reaction_type: "CO2R_OCHO",
        },
        {
          catalyst_elements: "Au",
          catalyst_facet: "211",
          potential: 0.0,
          reaction_type: "HER",
        },
        {
          catalyst_elements: "Pt",
          catalyst_facet: "111",
          potential: -0.5,
          reaction_type: "OER",
        },
      ];
      const newAutocompletes = [...autocompletes];
      const finalCol = getFinalKeySegment(col);
      const auto = templateData
        .map((item) => String(item[getFinalKeySegment(finalCol)]))
        .filter(
          (item) =>
            item !== null &&
            item !== undefined &&
            item !== "null" &&
            item !== "undefined",
        );
      newAutocompletes[index] = Array.from(new Set(auto)).sort();
      setAutocompletes(newAutocompletes);
    }
  };

  const handleSearchTextChange = (index, searchText) => {
    const newFilters = [...searchFilters];
    newFilters[index].searchText = searchText;
    setSearchFilters(newFilters);

    // if autocomplete is empty, then we need to update the autocomplete options
    if (autocompletes[index].length === 0) {
      const newAutocompletes = [...autocompletes];
      const finalCol = getFinalKeySegment(searchFilters[index].column);
      const auto = data
        .map((item) => String(item[getFinalKeySegment(finalCol)]))
        .filter(
          (item) =>
            item !== null &&
            item !== undefined &&
            item !== "null" &&
            item !== "undefined",
        );
      newAutocompletes[index] = Array.from(new Set(auto)).sort();
      setAutocompletes(newAutocompletes);
    }
  };

  const handleAddFilter = () => {
    setSearchFilters([...searchFilters, { column: "", searchText: "" }]);
    setAutocompletes([...autocompletes, []]);
  };

  useEffect(() => {
    setSearchFilters([
      {
        column: "reaction.reaction_type",
        searchText: "",
      },
    ]);
    setAutocompletes([...autocompletes, []]);
    handleColumnChange(0, "reaction.reaction_type");
  }, []);

  const handleRemoveFilter = (index) => {
    const newFilters = [...searchFilters];
    newFilters.splice(index, 1);
    setSearchFilters(newFilters);

    const newAutocompletes = [...autocompletes];
    newAutocompletes.splice(index, 1);
    setAutocompletes(newAutocompletes);
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setAutocompletes([{ column: "", searchText: "" }]);
    setSearchFilters([[]]);
    //setQueryParams({}); // Clear existing query parameters
  };

  const handleSearch = () => {
    if (!selectedCategory) {
      alert("Please select a query type.");
      return;
    }
    let queryParams = {};
    searchFilters.forEach((filter) => {
      if (filter.column && filter.searchText) {
        queryParams[filter.column] = filter.searchText;
      }
    });

    onSearch({ ...queryParams, query: selectedCategory });
  };

  // Disallow searching by catalyst formula or unique id
  let exclusions = ["reaction.catalyst_formula", "unique_id"];
  searchConfig.reaction = searchConfig.reaction.filter(
    (field) => !exclusions.includes(field),
  );

  return (
    <div style={{ textAlign: "left" }}>
      <Typography
        style={{ paddingLeft: "5px" }}
        variant="subtitle1"
        component="p"
      >
        Select Search Criteria:
      </Typography>
      {selectedCategory &&
        searchFilters.map((filter, index) => (
          <div key={index} style={{ display: "flex", alignItems: "center" }}>
            <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
              <Select
                value={filter.column}
                onChange={(e) => handleColumnChange(index, e.target.value)}
                //options={columnOptions}
                placeholder="Select Column"
              >
                {searchConfig[selectedCategory].map((key) => (
                  <MenuItem value={key}>
                    {snakeToTitle(getFinalKeySegment(key))}
                  </MenuItem>
                ))}
                {/* {columnOptions.map((column) => (
                                <MenuItem value={column.value}>
                                    {column.label}
                                </MenuItem>
                            ))} */}
              </Select>
            </FormControl>
            {/* <Input
                        type="text"
                        variant="standard"
                        sx={{ m: 1, minWidth: 200 }}
                        value={filter.searchText}
                        onChange={(e) => handleSearchTextChange(index, e.target.value)}
                        placeholder="Search Text"
                    /> */}
            <Autocomplete
              id="free-solo-search-text"
              freeSolo
              disableClearable
              options={autocompletes[index]}
              onChange={(e, v) => handleSearchTextChange(index, v)}
              disabled={filter.column === ""}
              renderInput={(params) => {
								params.inputProps.value = filter.searchText;
                return <TextField
                  {...params}
                  variant="standard"
									value={filter.searchText}
									defaultValue={filter.searchText}
                  onChange={(e) =>
                    handleSearchTextChange(index, e.target.value)
                  }
                  sx={{ m: 1, width: 300 }}
                  label="Search Text"
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                />
              }}
            />
            <Button
              variant="contained"
              onClick={() => handleRemoveFilter(index)}
            >
              Remove
            </Button>
          </div>
        ))}
      <Button variant="contained" sx={{ m: 1 }} onClick={handleAddFilter}>
        Add Search Criteria
      </Button>
      <Button variant="contained" sx={{ m: 1 }} onClick={handleSearch}>
        Search
      </Button>
    </div>
  );
};

export default ReactionSearchCriteria;
